<template>
<span class="find-shop" @click="findShop">
  <button class="btn btn-icon btn-primary">
    <template v-if="isProcess()">
      <span class="spinner-border spinner-border-sm me-2"></span>
    </template>
     <template v-if="!isProcess()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-basket-search">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M17 10l-2 -6" />
        <path d="M7 10l2 -6" />
        <path d="M11 20h-3.756a3 3 0 0 1 -2.965 -2.544l-1.255 -7.152a2 2 0 0 1 1.977 -2.304h13.999a2 2 0 0 1 1.977 2.304l-.215 1.227" />
        <path d="M13.483 12.658a2 2 0 1 0 -2.162 3.224" />
        <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
        <path d="M20.2 20.2l1.8 1.8" />
      </svg>
     </template>
  </button>
</span>
</template>

<script>
import {defineComponent, watch, reactive, ref} from "vue"
import Helper from "@/services/Helper"
import Api from "./services/Api"
import Notify from "@/services/Notify";

export default defineComponent({
  name: "FindShop",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let process = ref(false)

    const fields = reactive({
      link: null,
    })

    watch(() => props.payload, (val) => {
      if (Helper.isObject(val)) {
        updateFields(val)
      }
    }, {
      immediate: true,
    })

    function updateFields(query) {
      fields.link = query.link
    }

    function startProcess() {
      process.value = true
    }

    function stopProcess() {
      process.value = false
    }

    function isProcess() {
      return process.value === true
    }

    function pushEvent(val) {
      emit("onFind", val)
    }

    function findShop() {
      if (!fields.link) {
        Notify.info("Необходимо заполнить основную ссылку")
        return
      }

      startProcess()

      Api.shopDetect({
        link: fields.link
      }).then((resp) => {
        let items = resp?.data?.items

        if (Helper.isEmpty(items) || !Helper.isArray(items) || items.length === 0) {
          pushEvent({
            shop_id: null,
            find_many_shop: false,
          })

          return false
        }

        if (items.length > 1) {
          pushEvent({
            shop_id: null,
            find_many_shop: true,
          })

          return false
        }

        pushEvent({
          shop_id: items[0],
          find_many_shop: false,
        })

        return false
      }).catch(() => {
      }).finally(() => {
        stopProcess()
      })
    }

    return {
      isProcess,
      findShop,
    }
  }
})
</script>
